/* window.BotProfile: оболочка собрана компонентом, контракт PAGES тот же (init, mount, fill, after, planChanged). */
import { definePageModule } from '../../bridge/page-module';
import { Profile } from './Profile';
import { isServerMode } from '../../platform/server-mode';
import { createProfile } from './engine';
import { profileServer, type ProfileServer } from './profile-server';

const SKIP = new Set(['markup', 'prepare', 'attach', 'init', 'unmount', 'S', 'fill', 'after', 'PREFIX', 'TESTS', 'mounted']);

export interface ProfileView {
  body: string;
  sheets: string;
}

export interface ProfileApi {
  prepare: () => ProfileView;
  attach: () => void;
  init: (o: BotPageUi | { server: ProfileServer }) => void;
  unmount: () => void;
  fill: (...args: unknown[]) => void;
  after: () => void;
  S: object;
  PREFIX: string;
  TESTS: [string, [string, string][]][];
}

let api: ProfileApi;

/** Экран берёт api при отрисовке: installProfile уже вызван */
export function profileApi() {
  return api;
}

/** Методы и геттеры раздела, кроме тех, что забирает контракт страницы */
function liveExtras(b: object): Record<string, unknown> {
  const extra: Record<string, unknown> = {};
  for (const [k, d] of Object.entries(Object.getOwnPropertyDescriptors(b))) {
    if (SKIP.has(k)) continue;
    if (d.get) Object.defineProperty(extra, k, { enumerable: true, get: () => (b as Record<string, unknown>)[k] });
    else if (typeof d.value === 'function') {
      const fn = d.value as (...args: unknown[]) => unknown;
      extra[k] = (...args: unknown[]) => fn.apply(b, args);
    } else extra[k] = d.value;
  }
  return extra;
}

export function installProfile() {
  const server = isServerMode();
  const b = createProfile() as unknown as ProfileApi;
  api = b;
  // Раздел один и тот же: в серверной сборке данные идут из API, в прототипе — из демо-слоя.
  if (server) b.init({ server: profileServer });
  definePageModule({
    global: 'BotProfile',
    PREFIX: b.PREFIX,
    TESTS: server ? [] : b.TESTS,
    S: b.S,
    Page: Profile,
    init(o) {
      b.init(o);
    },
    fill(...args: unknown[]) {
      if (!server) b.fill(...args);
    },
    after() {
      b.after();
    },
    beforeUnmount() {
      b.unmount();
    },
    extra: liveExtras(b),
  });
}
